import { Controller } from "@hotwired/stimulus"

// Polls the team data index JSON and updates publish status in the list until no items are pending.
export default class extends Controller {
  static values = {
    pollUrl: String,
  }

  connect() {
    this.pollInterval = null
    this.startPollingIfPending()
  }

  disconnect() {
    this.stopPolling()
  }

  startPollingIfPending() {
    if (this.hasPending()) {
      this.schedulePoll()
    }
  }

  hasPending() {
    return this.element.matches('[data-publish-status="pending"]') || this.element.querySelector('[data-publish-status="pending"]') != null
  }

  schedulePoll() {
    if (this.pollInterval) return
    this.pollInterval = setInterval(() => this.poll(), 2000)
  }

  stopPolling() {
    if (this.pollInterval) {
      clearInterval(this.pollInterval)
      this.pollInterval = null
    }
  }

  async poll() {
    if (!this.pollUrlValue) return
    try {
      const res = await fetch(this.pollUrlValue, { headers: { Accept: "application/json" } })
      if (!res.ok) return
      const data = await res.json()
      this.applyStatuses(data.team_data || [])
      if (!this.hasPending()) {
        this.stopPolling()
      }
    } catch (_e) {
      // ignore network errors, will retry
    }
  }

  applyStatuses(teamData) {
    teamData.forEach((d) => {
      const row = this.element.matches(`[data-datum-id="${d.id}"]`)
        ? this.element
        : this.element.querySelector(`[data-datum-id="${d.id}"]`)
      if (!row) return
      row.setAttribute("data-publish-status", d.publish_status || "pending")
      const statusEl = row.querySelector("[data-role=\"publish-status\"]")
      if (statusEl) {
        statusEl.innerHTML = this.statusHtml(d)
      }
      const statusTextEl = row.querySelector("[data-role=\"publish-status-text\"]")
      if (statusTextEl) {
        statusTextEl.textContent = d.publish_status || "pending"
      }
    })
  }

  statusHtml(d) {
    const status = d.publish_status || "pending"
    if (status === "published" && d.geoserver_layer_id) {
      return `<code class="small">${this.escapeHtml(d.geoserver_layer_id)}</code>`
    }
    if (status === "failed") {
      const msg = (d.publish_error || "Unknown error").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;")
      return `<div class="alert alert-danger small py-2 mb-0" role="alert"><strong>Publish failed:</strong> ${msg}</div>`
    }
    return '<span class="text-muted small">Publishing to GeoServer…</span>'
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }
}
